export default "__VITE_ASSET__CIrDo8$2__"